<template>
    <div>
        <div class="hidden sm:block">
            <div class="flex justify-center">
                <div v-for="(cat, k) in catList" :key="k">
                    <CatMenuItem
                            :category="cat"
                            class="mx-1"
                            :isActive="activeIndex == k"
                            @click="clickTab(k)"
                    ></CatMenuItem>
                </div>
            </div>
        </div>
        <div class="block sm:hidden">
            <div class="splide custom-slide" id="cate-menu-slide">
                <div class="splide__track">
                    <ul class="splide__list">
                        <li class="splide__slide"
                            v-for="(cat, k) in catList"
                            :key="k"
                            @click="clickTab(k)">
                            <CatMenuItem
                                    :category="cat"
                                    :isActive="activeIndex == k"
                            ></CatMenuItem>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
//library
import Splide from '@splidejs/splide'; //https://splidejs.com/
//helper
import Util from '@/helper/Utility.js';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
//component
import CatMenuItem from './CatMenuItem.vue';

export default {
    name: 'CatSlider',
    mixins: [LocaleMixin],
    components: {
        CatMenuItem,
    },
    props: {
        catList: { type: Array, required: true },
    },
    data: function() {
        return {
            activeIndex: 0,
            slide: {
                isDown: false,
                startX: 0,
                scrollLeft: 0,
            },
        };
    },
    created: function() {
        Util.log('cat menu', this.catList);
        this.setDefaultTab();
        this.setSlider();
    },
    methods: {
        setDefaultTab: function() {
            let catId = this.$route.params.catId;

            if (!Util.isEmptyStr(catId)) {
                for (let i in this.catList) {
                    if (this.catList[i].id == catId) {
                        this.activeIndex = i;
                        break;
                    }
                }
            }
        },
        catName: function(cat) {
            return this.localeCode == 1033 ? cat.nameEn : cat.nameTh;
        },
        clickTab: function(index) {
            this.activeIndex = index;
            let send = {
                index: index,
                cat: this.catList[index],
            };
            this.$emit('clickTab', send);
        },

        setSlider: function() {
            this.$nextTick(() => {
                new Splide('#cate-menu-slide', {
                    arrows: false,
                    padding: 0,
                    gap: 10,
                    pagination: false,
                    focus: 'center',
                    fixedWidth: 150,
                }).mount();
            });
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
